export const AUTH_DETAIL = 'AUTH_DETAIL';

export const ACCESS_TOKEN = 'ACCESS_TOKEN';
